<template>
    <v-container class="fill-height data-container" style="padding: 0px;" fluid>
        <v-form v-model="allParamsValid" ref="form" style="width: 100%">
            <h2 class="title" v-text="reportTitle"></h2>

            <v-menu>
                <template v-slot:activator="{ on }">
                    <v-btn class="mx-1 grid-button" fab dark x-small color="#c42111" v-on="on" title="Quickload Params">
                        <v-icon style="transform: rotate(180deg);">mdi-menu</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="applyQuickload(quickload)" v-for="quickload in $props.reportDetails.quickload_configs">
                        <v-list-item-title><v-icon style="transform: scaleX(-1)">mdi-keyboard-return</v-icon> {{`${quickload.name}`}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showManageQuickloadsClick">
                        <v-list-item-title><v-icon>settings</v-icon> Manage Quick Loads</v-list-item-title>
                    </v-list-item>


                    <v-list-item @click="copyReportParamsApiData">
                        <v-list-item-title><v-icon>mdi-code-json</v-icon> Copy Params Data</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn class="mx-1 grid-button" fab dark x-small color="#c42111" title="Report Notes" @click="$emit('notes')" v-on="on">
                        <v-icon>mdi-script-text</v-icon>
                    </v-btn>
                </template>
                <span>Report Notes</span>
            </v-tooltip>

            <v-row justify="start" :key="componentKey">
                <v-col cols="12" lg="6" xl="4" align-self="start" justify v-for="param in reportDetails.rpt_params">

                    <div class="param-container">
                        <span class="param-title" v-text="param.rpt_param_user_name" />
                        <!-- single select -->
                        <template v-if="param.rpt_param_type == '1d'">
                            <single-select :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- multi select -->
                        <template v-else-if="param.rpt_param_type == '1d_multi'">
                            <multi-select :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- date range -->
                        <template v-else-if="param.rpt_param_type == 'date_range'">
                            <date-range :param="param" @edit="actionButtonLocked = false"></date-range>
                        </template>

                        <!-- time range -->
                        <template v-else-if="param.rpt_param_type == 'time_range'">
                            <time-range :param="param" @edit="actionButtonLocked = false"></time-range>
                        </template>

                        <!-- text box -->
                        <template v-else-if="param.rpt_param_type == 'text_box'">
                            <text-box :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- site select -->
                        <template v-else-if="param.rpt_param_type == 'site_select'">
                            <site-select :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- busy hour -->
                        <template v-else-if="param.rpt_param_type == 'busy_hour'">
                            <busy-hour :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- dynamic busy hour -->
                        <template v-else-if="param.rpt_param_type == 'dynamic_busy_hour'">
                            <dynamic-busy-hour :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- custom select -->
                        <template v-else-if="param.rpt_param_type == 'custom_select'">
                            <custom-select :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- date -->
                        <template v-else-if="param.rpt_param_type == 'date'">
                            <date :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- time -->
                        <template v-else-if="param.rpt_param_type == 'time'">
                            <Time :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- busy hour daily -->
                        <template v-else-if="param.rpt_param_type == 'busy_hour_daily'">
                            <busy-hour-daily :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- double single select -->
                        <template v-else-if="param.rpt_param_type == '2d'">
                            <double-select :param="param" @edit="actionButtonLocked = false" />
                        </template>

                        <!-- parameter select -->
                        <template v-else-if="param.rpt_param_type == 'parameter_select'">
                            <parameter-select :param="param" @edit="actionButtonLocked = false" />
                        </template>


                        <template v-else>
                            {{param.rpt_param_type}} - PARAM INPUT NOT YET IMPLEMENTED
                        </template>
                    </div>

                </v-col>
            </v-row>

            <div class="run-incognito-container mt-3 mb-3" v-if="$props.actionButtonText == 'Run Report'">
                <v-checkbox class="run-incognito-checkbox ml-4" :class="{disabled: !hasPermissions}" :disabled="!hasPermissions" :value="$props.runIncognito" @change="$emit('runIncognito', $event)" color="#c42111" label="Hide History" />
                <v-tooltip bottom color="rgba(48, 48, 48, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="hover-help" :class="{disabled: !hasPermissions}">mdi-information</v-icon>
                    </template>
                    <span :class="{disabled: !hasPermissions}">This prevents an entry from being added to Report History</span>
                </v-tooltip>
            </div>

            <v-btn class="report-action-button mt-3" @click="actionClick(null)" v-if="$props.actionButtonText && $props.actionButtonText != 'Run Report'">{{$props.actionButtonText}}</v-btn>

            <v-btn-toggle v-if="$props.actionButtonText == 'Run Report'">
                <v-btn width="232" height="48" class="report-action-button left mt-3" @click="actionClick($props.reportFilters.report_run_method)" v-if="$props.actionButtonText" :disabled="($props.reportFilters.report_run_method == 'email' && !$store.state.user.user_page_email) || actionButtonLocked">{{runReportButtonText}}</v-btn>
                <v-menu rounded min-width="280" max-width="280" nudge-left="232" nudge-bottom="52">
                    <template v-slot:activator="{ attrs, on }">
                        <v-btn class="report-action-button right mt-3" height="48" min-width="48" max-width="48" v-on="on" :disabled="actionButtonLocked"><v-icon>mdi-chevron-down</v-icon></v-btn>
                    </template>
                    <v-list color="#303030" style="padding: 0px;">
                        <v-list-item class="report-action-button-list-item" style="padding-top: 8px; padding-bottom: 8px;" @click="actionClick('run')">
                            <div class="report-action-button-option">
                                <span class="option-title">Run report</span>
                                <span class="option-text">This will run the report now and display the results when finished.</span>
                                <v-icon small class="selected-option" v-if="$props.reportFilters.report_run_method == 'run'">mdi-check</v-icon>
                            </div>
                        </v-list-item>
                        <v-divider />
                        <v-list-item class="report-action-button-list-item" style="padding-top: 8px; padding-bottom: 8px;" @click="actionClick('background')">
                            <div class="report-action-button-option">
                                <span class="option-title">Run report in background</span>
                                <span class="option-text">This will run the report in the background. You can access the results via the reports app-bar icon.</span>
                                <v-icon small class="selected-option" v-if="$props.reportFilters.report_run_method == 'background'">mdi-check</v-icon>
                            </div>
                        </v-list-item>
                        <v-divider />
                        <v-list-item class="report-action-button-list-item" style="padding-top: 8px; padding-bottom: 8px;" @click="actionClick('email')" :disabled="!$store.state.user.user_page_email">
                            <div class="report-action-button-option">
                                <span class="option-title">Run report email results</span>
                                <span class="option-text">This will run the report in the background and email the results as a csv file.</span>
                                <v-icon small class="selected-option" v-if="$props.reportFilters.report_run_method == 'email'">mdi-check</v-icon>
                            </div>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-btn-toggle>

        </v-form>

        <v-dialog v-model="showManageQuickloads" max-width="80%" width="600px" persistent v-if="showManageQuickloads" @keydown="(k) => {k.key == 'Escape' ? showManageQuickloads = false : null}">
            <manage-quickloads :reportDetails="$props.reportDetails" @cancel="showManageQuickloads = false" @save="saveQuickloads" @apply="applyQuickload"></manage-quickloads>
        </v-dialog>

    </v-container>
</template>

<script>
import DateRange from '@/components/Reports/ReportInputs/DateRange';
import TimeRange from '@/components/Reports/ReportInputs/TimeRange';
import TextBox from '@/components/Reports/ReportInputs/TextBox';
import SingleSelect from '@/components/Reports/ReportInputs/SingleSelect';
import MultiSelect from '@/components/Reports/ReportInputs/MultiSelect';
import SiteSelect from '@/components/Reports/ReportInputs/SiteSelect';
import BusyHour from '@/components/Reports/ReportInputs/BusyHour';
import DynamicBusyHour from '@/components/Reports/ReportInputs/DynamicBusyHour';
import CustomSelect from '@/components/Reports/ReportInputs/CustomSelect';
import Date from '@/components/Reports/ReportInputs/Date';
import Time from '@/components/Reports/ReportInputs/Time';
import BusyHourDaily from '@/components/Reports/ReportInputs/BusyHourDaily';
import DoubleSelect from '@/components/Reports/ReportInputs/DoubleSelect';
import ParameterSelect from '@/components/Reports/ReportInputs/ParameterSelect';
import ManageQuickloads from '@/components/Reports/ManageQuickloads';
export default {
    name: 'ReportParams',
    components: {
        DateRange,
        TimeRange,
        TextBox,
        SingleSelect,
        MultiSelect,
        SiteSelect,
        BusyHour,
        DynamicBusyHour,
        CustomSelect,
        Date,
        Time,
        BusyHourDaily,
        DoubleSelect,
        ParameterSelect,
        ManageQuickloads
    },
    props: ['reportTitle', 'reportDetails', 'actionButtonText', 'initalParamValues', 'collectMode', 'reportFilters', 'actionTrigger', 'runIncognito'],
    data: () => ({
        allParamsValid: true,
        showManageQuickloads: false,
        componentKey: 0,
        actionButtonLocked: false,
    }),

    computed: {
        runReportButtonText: function() {
            if(this.$props.reportFilters.report_run_method == 'background') {
                return 'run report background';
            }
            else if(this.$props.reportFilters.report_run_method == 'email') {
                return 'run report email';
            }
            else {
                return 'run report';
            }
        },

        hasPermissions() {
            return TELSA.checkPermission(this.$store.state.user, `reports/incognito`);
        }
    },

    methods: {
        actionClick: function(option) {
            if (this.$refs.form.validate()) {
                if(this.actionButtonLocked) {
                    return;
                }
                let paramArr = [];
                let humanTextArr = [];
                for(let param of this.reportDetails.rpt_params) {
                    paramArr.push(param.selectedValue);
                    humanTextArr.push(param.humanText);
                }
                console.log('action click: ', option);
                if(!option || option == 'run') {
                    this.$emit('action', paramArr, humanTextArr);
                }
                else if(option && option == 'background') {
                    this.$emit('background', paramArr, humanTextArr);
                }
                else if(option && option == 'email') {
                    this.$emit('email', paramArr, humanTextArr);
                }

                // Prevent spam clicking button
                let self = this;
                self.actionButtonLocked = true;
                // setTimeout(function() {
                //     self.actionButtonLocked = false;
                // }, 3000)
            }
        },

        setcollectModeOnParams: function() {
            for(let reportParam of this.$props.reportDetails.rpt_params) {
                reportParam.collectMode = this.$props.collectMode;
            }
        },

        applyInitalParams: function() {
            if(!this.$props.initalParamValues) {
                return;
            }
            const initalParamValues = this.$props.initalParamValues;
            for(let [index, reportParam] of this.$props.reportDetails.rpt_params.entries()) {
                reportParam.encodedValue = initalParamValues[index];
            }
        },

        showManageQuickloadsClick: function() {
            if (this.$refs.form.validate()) {
                this.showManageQuickloads = true;
            }
        },

        saveQuickloads: function(quickloads) {
            let route = (TELSA.apiHost + "report/quickloads");
            TELSA.loading(true);
            return this.$http.post(route, {args: {report: this.$props.reportTitle, quickloads: quickloads}}).then(response => {
                let result = response.body;
                this.$props.reportDetails.quickload_configs = quickloads;
                this.showManageQuickloads = false;
                TELSA.loading(false);
            });
        },

        applyQuickload: function(quickload) {
            for(let quickParam of quickload.params) {
                for(let reportParam of this.$props.reportDetails.rpt_params) {
                    if(quickParam.rpt_param_user_name == reportParam.rpt_param_user_name) {
                        // If its a date range param then we set the value from the "daysBack" value.
                        if(reportParam.rpt_param_type == "date_range") {
                            let endDate = TELSA.moment.tz(this.$store.state.batchConfig.timezone).format("YYYY-MM-DD");
                            let startDate = TELSA.moment.tz(this.$store.state.batchConfig.timezone).subtract(quickload.daysBack, 'days').format("YYYY-MM-DD");
                            reportParam.encodedValue = `${startDate} ${endDate}`;
                        }
                        else {
                            reportParam.encodedValue = quickParam.selectedValue;
                        }
                        break;
                    }
                }
            }
            this.componentKey++;
            this.showManageQuickloads = false;
        },

        copyReportParamsApiData: function() {
            let paramArr = [];
            let humanTextArr = [];
            for(let param of this.reportDetails.rpt_params) {
                paramArr.push(param.selectedValue);
                humanTextArr.push(param.humanText);
            }
            let args = {
                args: {
                    report: this.$props.reportTitle,
                    params: paramArr,
                    humanParams: humanTextArr,
                    noCache: false
                }
            };
            navigator.clipboard.writeText(JSON.stringify(args));
        }
    },

    watch: {
        actionTrigger: {
            handler(newVal, oldVal) {
                this.actionClick(null);
            },
            deep: true
        },
    },

    created() {
        this.setcollectModeOnParams();
        this.applyInitalParams();

        // TESTING
        // this.$props.reportDetails.rpt_params = [
        //     {rpt_param_user_name: '1d', rpt_param_type: '1d'},
        //     {rpt_param_user_name: '1d_multi', rpt_param_type: '1d_multi'},
        //     {rpt_param_user_name: 'date_range', rpt_param_type: 'date_range'},
        //     {rpt_param_user_name: 'time_range', rpt_param_type: 'time_range'},
        //     {rpt_param_user_name: 'text_box', rpt_param_type: 'text_box'},
        //     {rpt_param_user_name: 'dynamic_busy_hour', rpt_param_type: 'dynamic_busy_hour'},
        //     {rpt_param_user_name: 'date', rpt_param_type: 'date'},
        //     {rpt_param_user_name: 'time', rpt_param_type: 'time'},
        //     {rpt_param_user_name: 'busy_hour_daily', rpt_param_type: 'busy_hour_daily'},
        //     {rpt_param_user_name: '2d', rpt_param_type: '2d'},
        //     {rpt_param_user_name: 'parameter_select', rpt_param_type: 'parameter_select'},
        //     {rpt_param_user_name: 'site_select', rpt_param_type: 'site_select'},
        //     {rpt_param_user_name: 'busy_hour', rpt_param_type: 'busy_hour'},
        //     {rpt_param_user_name: 'custom_select', rpt_param_type: 'custom_select'},
        // ]
    }

  
};
</script>

<style scoped>

    .title {
        color: #ffffff;
        display: block;
        margin-bottom: 1em;
        display: inline-block;
    }

    .param-container {
        color: #ffffff;
        border: solid 1px rgba(0, 0, 0, 0.12);
        background: #303030;
        box-shadow: 4px 4px 5px -2px rgba(0, 0, 0, 0.6);
        border-radius: 5px;
        padding:  .5rem;

        min-height: 161px;
    }
    .param-container .param-title {
        display: block;
        font-size: 13pt;
    }

    .report-action-button {
        color: #ffffff;
        background-color: #c42111 !important;
        display: block;
    }
    .report-action-button.left {
        display: inline-block;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }
    .report-action-button.right {
        display: inline-block;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
    }

    .report-action-button-list-item:hover {
        background-color: #c42111;
    }

    .report-action-button-option {
        display: block;
        cursor: pointer;
        width: 100%;
        padding-left: 10px;
    }
    .report-action-button-option .option-title {
        font-weight: bold;
        display: block;
        font-size: 15px;
    }
    .report-action-button-option .option-text {
        display: block;
        font-size: 13px;
    }
    .report-action-button-option .selected-option {
        position: absolute;
        left: 5px;
        top: calc(50% - (16px / 2));
    }

    .run-incognito-container {
        height: 54px;
        width: 280px;
        display: block;
        border-radius: 4px;
        background-color: #303030;
        box-shadow: 4px 4px 5px -2px rgb(0 0 0 / 60%);
        border-radius: 5px;
        padding: 0.25rem;
        padding-left: 40px;
        position: relative;
        text-align: center;
    }

    .run-incognito-checkbox {
        display: block;
        margin-top: 7px;
    }

    .run-incognito-container .hover-help {
        position: absolute;
        right: 50px;
        top: 15px;
    }

    .run-incognito-container .hover-help.disabled {
        color: #757575;
    }

    .run-incognito-container .hover-help.disabled {
        color: #757575;
    }
    
</style>

<style>

    .run-incognito-checkbox .v-icon {
        font-size: 40px !important;
    }
    .run-incognito-checkbox label {
        left: 15px !important;
        font-size: 18px;
        color: #ffffff !important;
    }
    .run-incognito-checkbox.disabled label {
        color: #757575 !important;
    }

</style>

